"use strict";
exports.__esModule = true;
var mixin = {
    beforeMount: function () {
        var _this = this;
        var styleMapping = function (name) {
            var styles = Object.getOwnPropertyNames(_this).filter(function (k) {
                return k != '$styleMapping'
                    && /^\$style/.test(k);
            });
            for (var _i = 0, styles_1 = styles; _i < styles_1.length; _i++) {
                var style = styles_1[_i];
                var hash = _this[style][name];
                if (hash)
                    return hash;
            }
            return name;
        };
        if (this._c)
            this._c = wrapCreateElement(styleMapping, this._c);
        this.$createElement = wrapCreateElement(styleMapping, this.$createElement);
        this.$styleMapping = styleMapping;
    }
};
function install(vue) {
    vue.mixin(mixin);
}
exports["default"] = {
    install: install
};
function wrapCreateElement(styleMapping, oldCreate) {
    if (!oldCreate)
        return oldCreate;
    return function (tag, data, children) {
        if (data && styleMapping) {
            apply(data, 'class', styleMapping);
            apply(data, 'staticClass', styleMapping);
        }
        return oldCreate.apply(self, arguments);
    };
}
exports.wrapCreateElement = wrapCreateElement;
function apply(data, key, styleMapping) {
    var value = data[key];
    if (!value)
        return;
    if (typeof value == 'string') {
        data[key] = value.split(/\s/)
            .filter(function (a) { return a; })
            .map(styleMapping)
            .join(' ');
        return;
    }
    if (value instanceof Array) {
        for (var i = 0; i < value.length; i++) {
            apply(value, i, styleMapping);
        }
        return;
    }
    var mapped = {};
    for (var name_1 in value) {
        mapped[styleMapping(name_1)] = value[name_1];
    }
    data[key] = mapped;
}
//# sourceMappingURL=main.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@mfro/vue-specific-css/dist/main.js
// module id = 91
// module chunks = 1